import { gql } from "~/__generated__"

export const SUBSCRIPTION_PORTAL_SESSION_CREATE_MUTATION = gql(`
  mutation CREATE_PORTAL_SESSION($input: PortalSessionCreateInput!) {
    portalSessionCreate(input: $input) {
      sessionUrl
    }
  }
`)
